<script setup lang="ts">
import type { DataTableCellProps } from '@common';
import type { DecisionSupportItem } from '../models';
import { computed, toRefs } from 'vue';
import { DecisionSupportStatus } from '../enums';

const props = defineProps<DataTableCellProps<any, DecisionSupportItem>>();
const { item } = toRefs(props);

const statusColorMap: Record<DecisionSupportStatus, string> = {
  [DecisionSupportStatus.ERROR]: 'red',
  [DecisionSupportStatus.GENERATING]: 'blue',
  [DecisionSupportStatus.GENERATED]: 'green'
};

const chipColor = computed(() => statusColorMap[item.value.data.status]);
</script>

<template>
  <div>
    <v-chip :color="chipColor">{{ $t(`decisionSupport.status.${item.data.status}`) }}</v-chip>
  </div>
</template>
